import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PatientTagDTO } from "../../dtos/diseaseTags";
import {
  getAppointmentDetailsDto,
  getClinicPaymentDto,
  getDoctorPaymentDto,
  RefundPaymentDto,
  SpecialituesRegisterDTO,
  UpCommingDTO,
  VerifyAttachmentsDto,
} from "../../dtos/specialities";
import { SpecialityDelDTO } from "../../dtos/spec_deleteDtto";
import SpecialityService from "./specialityService";

const initialState = {
  specialities: [],
  dashboard: <any>[],
  data: [],
  patients: <any>[],
  patientsTag: <any>[],
  patient: <any>[],
  appoinment: <any>[],
  revenue: <any>[],
  upComming: [],

  registerspecialitiesPayload: null,
  editSpecialitiesInfoPayload: null,
  verifyAttachmentsPayload: null,
  appointmentDetails:null,

  isLoading: false,
  isLoadingTag: false,
  isSpecialitiesLoading: false,
  isEditSpecialitiesLoading: false,
  isRegisterSpecialitiesLoading: false,
  specialitiesId: "",

  isError: false,
  isRefundError: false,
  isAppoimentError: false,
  isRegisterSpecialitiesError: false,
  isEditSpecialitiesInfoError: false,
  isSpecialitiesLoadingError: false,

  isSuccess: false,
  isEditSpecialitiesInfoSuccess: false,

  message: "",
  refundMessage: "",
  Appoimentmessage: "",
  registerSpecialitiesMessage: "",
  specialitiesProfileErrorMessge: "",
  editSpecialitiesInfoMessage: "",
};

export const registerspecilities = createAsyncThunk(
  "/api/speciality/add",
  async (specilities: SpecialituesRegisterDTO, thunkAPI) => {
    try {
      return await SpecialityService.registerSpecilities(specilities);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getClinicPayment = createAsyncThunk(
  "/api/admin/clinic/payments/make",
  async (specilities: getClinicPaymentDto, thunkAPI) => {
    try {
      return await SpecialityService.getClinicPayments(specilities);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getDocPayment = createAsyncThunk(
  "/api/admin/doctor/payments/make",
  async (specilities: getDoctorPaymentDto, thunkAPI) => {
    try {
      return await SpecialityService.getDoctorPayments(specilities);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAppointmentDetails = createAsyncThunk(
  "/api/admin/appointment/data/get",
  async (specilities: getAppointmentDetailsDto, thunkAPI) => {
    try {
      return await SpecialityService.getAppointmentDetails(specilities);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const VerifyDrAttachments = createAsyncThunk(
  "/api/admin/doctor/payments/attachment/verify",
  async (attachment: VerifyAttachmentsDto, thunkAPI) => {
    try {
      return await SpecialityService.VerifyDocAttachments(attachment);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const VerifyClinicAttachments = createAsyncThunk(
  "/api/admin/clinic/payments/attachment/verify",
  async (attachment: VerifyAttachmentsDto, thunkAPI) => {
    try {
      return await SpecialityService.VerifyClinicAttachments(attachment);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllAppoiment = createAsyncThunk(
  "/api/admin/emareez/appointment/stats",
  async (dto: any, thunkAPI) => {
    try {
      return await SpecialityService.getAppoiment(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllRevenue = createAsyncThunk(
  "/api/admin/emareez/revenue/stats",
  async (dto: any, thunkAPI) => {
    try {
      return await SpecialityService.getRevenue(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllSpeciality = createAsyncThunk(
  "/api/speciality/all",
  async (_, thunkAPI) => {
    try {
      return await SpecialityService.getAllSpeciality();
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getDashboardDataApi = createAsyncThunk(
  "/api/admin/emareez/stats",
  async (_, thunkAPI) => {
    try {
      return await SpecialityService.getDashboardDataApi();
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllPatient = createAsyncThunk(
  "/api/admin/patient",
  async (_, thunkAPI) => {
    try {
      return await SpecialityService.getAllPatients();
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPatientTag = createAsyncThunk(
  "/api/admin/patient/pre-condition/get",
  async (dto: PatientTagDTO, thunkAPI) => {
    try {
      return await SpecialityService.PatientGetTags(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPatientcredit = createAsyncThunk(
  "/api/admin/patients/wallet/history",
  async (patient_id: any, thunkAPI) => {
    try {
      return await SpecialityService.getCreditPatients(patient_id);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAppoimentcredit = createAsyncThunk(
  "/api/admin/appointment/wallet/history",
  async (appointment_id: any, thunkAPI) => {
    try {
      return await SpecialityService.getAppoimentPatients(appointment_id);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const refundCredit = createAsyncThunk(
  "/api/admin/appointment/refund-payment",
  async (refund: RefundPaymentDto, thunkAPI) => {
    try {
      return await SpecialityService.getRefundPatients(refund);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editspeciality = createAsyncThunk(
  "/api/speciality/update",
  async (specilities: SpecialituesRegisterDTO, thunkAPI) => {
    try {
      return await SpecialityService.editspecilities(specilities);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deletespeciality = createAsyncThunk(
  "/api/speciality/delete",
  async (data: SpecialityDelDTO, thunkAPI) => {
    try {
      return await SpecialityService.deletespecilities(data);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const specialitySlices = createSlice({
  name: "specialitySlices",
  initialState,
  reducers: {
    reset: () => initialState,
    changespecilitiesId: (state, action) => {
      state.specialitiesId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(registerspecilities.pending, (state) => {
        state.isRegisterSpecialitiesLoading = true;
      })
      .addCase(registerspecilities.fulfilled, (state, action) => {
        state.isRegisterSpecialitiesLoading = false;
        state.isSuccess = true;
        state.registerspecialitiesPayload = action.payload;
        state.isRegisterSpecialitiesError = false;
        state.registerSpecialitiesMessage = "";
      })
      .addCase(
        registerspecilities.rejected,
        (state, action: PayloadAction<any>) => {
          state.isRegisterSpecialitiesLoading = false;
          state.isRegisterSpecialitiesError = true;
          state.registerSpecialitiesMessage = action.payload;
        }
      )

      .addCase(getAllSpeciality.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllSpeciality.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.specialities = action.payload;
        state.message = "";
      })
      .addCase(
        getAllSpeciality.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )

      .addCase(getClinicPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClinicPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.specialities = action.payload;
        state.message = "";
      })
      .addCase(
        getClinicPayment.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )

      .addCase(getDocPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDocPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.specialities = action.payload;
        state.message = "";
      })
      .addCase(getDocPayment.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAppointmentDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAppointmentDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.appointmentDetails = action.payload;
        state.message = "";
      })
      .addCase(getAppointmentDetails.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(VerifyDrAttachments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(VerifyDrAttachments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.verifyAttachmentsPayload = action.payload;
        state.message = "";
      })
      .addCase(
        VerifyDrAttachments.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )

      .addCase(VerifyClinicAttachments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(VerifyClinicAttachments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.verifyAttachmentsPayload = action.payload;
        state.message = "";
      })
      .addCase(
        VerifyClinicAttachments.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )

      .addCase(getDashboardDataApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDashboardDataApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.dashboard = action.payload;
        state.message = "";
      })
      .addCase(
        getDashboardDataApi.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )

      .addCase(getAllPatient.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPatient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.patients = action.payload;
        state.message = "";
      })
      .addCase(getAllPatient.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(getPatientTag.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPatientTag.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.patientsTag = action.payload;
        state.message = "";
      })
      .addCase(getPatientTag.rejected, (state, action: PayloadAction<any>) => {
        state.isLoadingTag = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(getPatientcredit.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPatientcredit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.patient = action.payload;
        state.message = "";
      })
      .addCase(
        getPatientcredit.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )

      .addCase(getAppoimentcredit.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAppoimentcredit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.patients = action.payload;
        state.Appoimentmessage = "";
      })
      .addCase(
        getAppoimentcredit.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isAppoimentError = true;
          state.Appoimentmessage = action.payload;
        }
      )

      .addCase(refundCredit.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(refundCredit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.patients = action.payload;
        state.refundMessage = "";
      })
      .addCase(refundCredit.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isRefundError = true;
        state.refundMessage = action.payload;
      })

      .addCase(editspeciality.pending, (state) => {
        state.isEditSpecialitiesLoading = true;
      })
      .addCase(editspeciality.fulfilled, (state, action) => {
        state.isEditSpecialitiesLoading = false;
        state.isEditSpecialitiesInfoSuccess = true;
        state.isEditSpecialitiesInfoError = false;
        state.editSpecialitiesInfoMessage = "";
        state.editSpecialitiesInfoPayload = action.payload;
      })
      .addCase(editspeciality.rejected, (state, action: PayloadAction<any>) => {
        state.isEditSpecialitiesLoading = false;
        state.isEditSpecialitiesInfoError = true;
        state.editSpecialitiesInfoMessage = action.payload;
      })

      .addCase(getAllAppoiment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllAppoiment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.appoinment = action.payload;
        state.message = "";
      })
      .addCase(
        getAllAppoiment.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      )

      .addCase(getAllRevenue.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllRevenue.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.revenue = action.payload;
        state.message = "";
      })
      .addCase(getAllRevenue.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(deletespeciality.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletespeciality.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = "";
      })
      .addCase(
        deletespeciality.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }
      );
  },
});

export const { reset, changespecilitiesId } = specialitySlices.actions;
export default specialitySlices.reducer;
